import { render, staticRenderFns } from "./LogIntegracaoSigaCall.vue?vue&type=template&id=76c9657f&"
import script from "./LogIntegracaoSigaCall.vue?vue&type=script&lang=js&"
export * from "./LogIntegracaoSigaCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports